import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const Equity: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon
      fill={fill}
      viewBox="0 0 70 70"
      height={height}
      width={width}
      {...rest}
    >
      <path
        d="M8 48.53C8 48.53 13.38 43.15 18.77 44.22C24.15 45.3 27.38 46.37 31.69 46.37H39.23C39.23 46.37 44.61 47.45 45.69 47.45C46.77 47.45 48.92 47.45 51.07 46.37C53.22 45.29 55.38 42.06 57.53 42.06C59.68 42.06 62.91 43.14 61.84 46.37C60.76 49.6 53.23 56.06 53.23 56.06C53.23 56.06 48.92 61.44 43.54 61.44H17.69L8 48.53Z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M50.02 59.17L61.07 48.12C61.79 47.4 62.19 46.43 62.19 45.4C62.19 44.37 61.79 43.41 61.07 42.68C59.57 41.18 57.13 41.18 55.64 42.68L48.52 49.8C48.51 51.98 46.73 53.74 44.55 53.74H34.36C34.36 53.74 34.3 53.71 34.3 53.68C34.3 53.65 34.33 53.62 34.36 53.62H44.55C46.67 53.62 48.39 51.9 48.39 49.78C48.39 47.66 46.67 45.94 44.55 45.94H28.76C28.76 45.94 28.74 45.94 28.73 45.94C26.62 44.91 24.55 44.22 21.33 44.22C15.39 44.22 10.26 48.45 8.00999 50.69L16.62 61.46L25.01 61.58H44.55C46.65 61.58 48.63 60.76 50.12 59.27L61.17 48.22C61.92 47.47 62.33 46.48 62.33 45.41C62.33 44.34 61.92 43.35 61.17 42.6C59.62 41.05 57.1 41.05 55.56 42.6L48.52 49.64C48.44 47.52 46.69 45.82 44.55 45.82H28.78C26.66 44.78 24.58 44.09 21.33 44.09C15.3 44.09 10.64 47.85 8.39999 50.1C8.36999 50.13 8.36999 50.17 8.39999 50.19"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M50.02 59.17L61.07 48.12C61.79 47.4 62.19 46.43 62.19 45.4C62.19 44.37 61.79 43.41 61.07 42.68C59.57 41.18 57.13 41.18 55.64 42.68L48.52 49.8C48.51 51.98 46.73 53.74 44.55 53.74H34.36C34.36 53.74 34.3 53.71 34.3 53.68C34.3 53.65 34.33 53.62 34.36 53.62H44.55C46.67 53.62 48.39 51.9 48.39 49.78C48.39 47.66 46.67 45.94 44.55 45.94H28.76C28.76 45.94 28.74 45.94 28.73 45.94C26.62 44.91 24.55 44.22 21.33 44.22C15.39 44.22 10.26 48.45 8.00999 50.69L16.62 61.46L25.01 61.58H44.55C46.65 61.58 48.63 60.76 50.12 59.27L61.17 48.22C61.92 47.47 62.33 46.48 62.33 45.41C62.33 44.34 61.92 43.35 61.17 42.6C59.62 41.05 57.1 41.05 55.56 42.6L48.52 49.64C48.44 47.52 46.69 45.82 44.55 45.82H28.78C26.66 44.78 24.58 44.09 21.33 44.09C15.3 44.09 10.64 47.85 8.39999 50.1C8.36999 50.13 8.36999 50.17 8.39999 50.19"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.77 61.45C18.77 62.63 17.8 63.6 16.62 63.6H10.15C8.97 63.6 8 62.63 8 61.45V44.22C8 43.04 8.97 42.07 10.15 42.07H16.61C17.79 42.07 18.76 43.04 18.76 44.22"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M18.77 61.45C18.77 62.63 17.8 63.6 16.62 63.6H10.15C8.97 63.6 8 62.63 8 61.45V44.22C8 43.04 8.97 42.07 10.15 42.07H16.61C17.79 42.07 18.76 43.04 18.76 44.22"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.23 44.76V63.06"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.04 16.92V7.39H29.53V13.01"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M25.04 16.92V7.39H29.53V13.01"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#424242"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.18 39.27C22.63 39.27 22.18 38.82 22.18 38.27V21.25C22.18 20.94 22.32 20.65 22.57 20.46L36.5 9.62C36.68 9.48 36.9 9.41 37.11 9.41C37.32 9.41 37.56 9.48 37.74 9.63L51.67 20.88C51.9 21.07 52.04 21.36 52.04 21.66V38.26C52.04 38.81 51.59 39.26 51.04 39.26H23.19L23.18 39.27Z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M37.1 10.41L51.03 21.66V38.26H23.18V21.24L37.11 10.4M37.1 8.41C36.67 8.41 36.23 8.55 35.87 8.83L21.94 19.67C21.45 20.05 21.17 20.63 21.17 21.25V38.27C21.17 39.37 22.07 40.27 23.17 40.27H51.02C52.12 40.27 53.02 39.37 53.02 38.27V21.67C53.02 21.07 52.75 20.49 52.28 20.11L38.36 8.86C37.99 8.56 37.55 8.42 37.1 8.42V8.41Z"
        fill="#424242"
      />
      <path
        d="M53.29 24.64C53.06 24.64 52.84 24.56 52.65 24.41L37.08 11.51L21.06 24.38C20.88 24.52 20.66 24.6 20.43 24.6C20.39 24.6 20.36 24.6 20.32 24.6C20.06 24.57 19.81 24.44 19.65 24.23L18.09 22.29C17.74 21.86 17.81 21.23 18.24 20.88L36.49 6.22C36.67 6.07 36.89 6 37.12 6C37.35 6 37.57 6.08 37.76 6.23L55.52 20.95C55.72 21.12 55.85 21.36 55.88 21.63C55.91 21.9 55.82 22.16 55.65 22.36L54.06 24.28C53.86 24.52 53.58 24.64 53.29 24.64Z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M37.12 7L54.88 21.72L53.29 23.64L37.09 10.21L20.43 23.59L18.87 21.65L37.12 7ZM37.12 5C36.68 5 36.23 5.15 35.87 5.44L17.63 20.09C16.77 20.78 16.63 22.04 17.32 22.9L18.88 24.84C19.21 25.25 19.7 25.52 20.22 25.58C20.29 25.58 20.36 25.59 20.44 25.59C20.89 25.59 21.34 25.44 21.69 25.15L37.07 12.79L52.01 25.17C52.38 25.48 52.84 25.63 53.29 25.63C53.86 25.63 54.44 25.38 54.83 24.91L56.42 22.99C56.76 22.58 56.92 22.06 56.87 21.53C56.82 21 56.56 20.52 56.15 20.18L38.39 5.46C38.02 5.15 37.57 5 37.11 5H37.12Z"
        fill="#424242"
      />
      <path
        d="M32.2 31.62C33 31.32 33.63 30.67 33.63 29.41C33.63 29.09 33.59 28.8 33.56 28.5H32.3V26.31H33.06C32.93 25.77 32.84 25.23 32.84 24.62C32.84 22.06 34.86 20.69 37.7 20.69C39.31 20.69 40.41 21.04 41.33 21.62V24.09H40.05C39.55 23.68 38.96 23.35 38.01 23.35C37.06 23.35 36.3 23.76 36.3 24.83C36.3 25.31 36.34 25.81 36.41 26.31H39.41V28.5H36.68C36.7 28.76 36.72 29.02 36.72 29.26C36.72 30.09 36.37 30.78 36.02 31.17H41.49V33.84H32.2V31.61V31.62Z"
        fill="#E81C30"
        className={styles.accentColor}
      />
    </Icon>
  )
}
